import { useState } from "react";
import { apiClient } from "../../apis/api-client";
import { decryptPayload } from "../../apis/crypto";
// @ts-ignore: missing type declarations for apimethod.js
import { API } from "../../Services/apimethod.js"
// @ts-ignore: missing type declarations for apimethod.js
import {getTokenExp,decryptData} from "@/Services/req_res_decode_encode";
import toast from 'react-hot-toast';

export default function PremiumCard() {
  const [gender, setGender] = useState("");
  const [age, setAge] = useState("");
  const [rop, setRop] = useState("No");
  const [pt, setPt] = useState(20);
  const [ppt, setPpt] = useState(10);
  const [saInput, setSaInput] = useState("");
  const [errors, setErrors] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(false);

  const [result, setResult] = useState<{
    kind: "ok" | "warn";
    amount: string;
    note: string;
  } | null>(null);

  const handlePt = (v: number) => {
    setPt(v);

    if (ppt > v) {
      setPpt(v);
    }
  };

  const handlePpt = (v: number) => {
    setPpt(Math.min(v, pt));
  };

  const formatSA = (raw: string) => {
    const digits = raw.replace(/[^0-9]/g, "");

    if (!digits) return "";

    return Number(digits).toLocaleString("en-IN");
  };

  const validateSAOnBlur = () => {
    let v = parseInt(saInput.replace(/,/g, "")) || 0;
    if (v > 0) {
      if (v < 2500000) v = 2500000;
      if (v > 5000000) v = 5000000;
      setSaInput(v.toLocaleString("en-IN"));
    }
  };

  const calculate = async () => {
    const errs: Record<string, boolean> = {};

    if (!gender) errs.gender = true;
    if (!age) errs.age = true;
    if (!saInput) errs.sa = true;

    setErrors(errs);

    if (Object.keys(errs).length) {
      setResult({
        kind: "warn",
        amount: "⚠ Please fill all fields.",
        note: "",
      });

      return;
    }

    const ageVal = parseInt(age);
    const saRaw = parseInt(saInput.replace(/,/g, "")) || 0;

    if (!ageVal || ageVal < 18 || ageVal > 65) {
      setResult({
        kind: "warn",
        amount: "⚠ Entry age must be between 18 – 65.",
        note: "",
      });
      return;
    }

    try {
       if(getTokenExp()){
             localStorage.clear();
             toast.error('Your login is expired!');
            setTimeout(() => {
                window.location.href = import.meta.env.VITE_LOGINURL;
            }, 2000);
            return false
        }
      setLoading(true);
      const payload = {
        gender,
        age: ageVal,
        rop,
        pt,
        ppt,
        sumAssured: saRaw,
      };
      const response = await API.CreateMethod("calculate-premium", payload);
      const decryptedData = decryptData(response?.data);
      if (response?.status==200) {
        const data = decryptedData?.data;
        setResult({
          kind: "ok",
          amount: `₹ ${Number(data?.premium).toLocaleString("en-IN")}`,
          note: `✓ Rate: ${data?.rate}`,
        });
      } else {
        setResult({
          kind: "warn",
          amount: "✕ Unable to calculate premium.",
          note: "",
        });
      }
    } catch (error) {


      setResult({
        kind: "warn",
        amount: "✕ API Error. Please try again.",
        note: "",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <label>Gender</label>

      <select
        value={gender}
        onChange={(e) => setGender(e.target.value)}
        className={errors.gender ? "cc-error" : ""}
      >
        <option value="">Select</option>
        <option>Male</option>
        <option>Female</option>
      </select>

      <label>Age</label>

      <input
        type="number"
        placeholder="18 – 65"
        min={18}
        max={65}
        value={age}
        onChange={(e) => setAge(e.target.value)}
        className={errors.age ? "cc-error" : ""}
      />

      <label>ROP (Return of Premium)</label>

      <select value={rop} onChange={(e) => setRop(e.target.value)}>
        <option>No</option>
        <option>Yes</option>
      </select>

      <label>Policy Term (PT)</label>

      <div className="cc-range-row">
        <input
          type="range"
          min={5}
          max={30}
          value={pt}
          onChange={(e) => handlePt(parseInt(e.target.value))}
        />

        <span className="cc-range-val">{pt}</span>
      </div>

      <label>Premium Payment Term (PPT)</label>

      <div className="cc-range-row">
        <input
          type="range"
          min={4}
          max={pt}
          value={ppt}
          onChange={(e) => handlePpt(parseInt(e.target.value))}
        />

        <span className="cc-range-val">{ppt}</span>
      </div>

      <label>Sum Assured (₹)</label>

      <input
        placeholder="e.g. 25,00,000"
        value={saInput}
        onChange={(e) => {
          let v = e.target.value.replace(/[^0-9]/g, "");
          if(parseInt(v) > 5000000){
            v = "5000000";
          }
          setSaInput(formatSA(v))
        }}
        onBlur={validateSAOnBlur}
        className={errors.sa ? "cc-error" : ""}
      />

      <div className="cc-hint">Min ₹25 Lac | Max  ₹50 Lac</div>

      {result && (
        <div className={`cc-result-box cc-show ${result.kind === "warn" ? "cc-warn" : ""}`}>
          <div className="cc-result-label">Annualised Premium</div>

          <div className="cc-result-amount">{result.amount}</div>

          {/* <div className="cc-result-note">{result.note}</div> */}
        </div>
      )}

      <button className="cc-btn cc-btn-blue" onClick={calculate} disabled={loading}>
        {loading ? "Calculating..." : "Calculate Premium"}
      </button>
    </>
  );
}
